export const convertirLetraMayus = (texto = '', capitalize = false) => {
    if(typeof(texto) !== 'string') return texto;
   
    let arrayTexto = texto.split(' ');

    if(!capitalize) {
        const primerPalabra = arrayTexto[0];
        if(primerPalabra.includes('¿')) {
            arrayTexto[0] = primerPalabra.charAt(1).toUpperCase() + primerPalabra.slice(2);
            arrayTexto[0] = '¿' + arrayTexto[0];
        }else
            arrayTexto[0] = primerPalabra.charAt(0).toUpperCase() + primerPalabra.slice(1);
    }else {
        arrayTexto = arrayTexto.map(t => t.charAt(0).toUpperCase() + t.slice(1));
    }

    return arrayTexto.join(' ');
}